"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PredictionQuestionStartButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const styled_1 = require("@framework/styled");
const PredictionQuestionStartButton = (props) => {
    const { className, disabled, variant = styled_1.ListActionVariant.iconButton, question } = props;
    const handleClick = () => {
        console.info("CLICK");
    };
    if (question.startTimestamp) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleClick, icon: icons_material_1.PlayArrow, message: "form.buttons.start", className: className, dataTestId: "PredictionQuestionStartButton", disabled: disabled, variant: variant }));
};
exports.PredictionQuestionStartButton = PredictionQuestionStartButton;
//# sourceMappingURL=index.js.map